import React from 'react';
import {
    Typography,
    Button,
    App,
    Dropdown,
} from 'antd';
import {
    MoreOutlined
} from '@ant-design/icons';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from '../../../config/axios';

const TransactionStatusModal = ({ order }) => {

    const { message, modal } = App.useApp();

    // const [messageApi, contextHolder] = message.useMessage();
    const queryClient = useQueryClient();

    const { mutate } = useMutation({
        mutationFn: ({ values, id }) => {
            axios
                .put(`/api/transaction/changeOrderStatus/${id}`, values)
                .then(res => {
                    // console.log("create customer :",res);
                    message.success({
                        content: 'บันทึกข้อมูลสำเร็จ',
                        duration: 1,
                        onClose: () => queryClient.invalidateQueries(['/api/transaction/getOrders'])
                    })
                })
                .catch(err => {
                    console.log(err)
                    message.error({
                        content: 'ไม่สามารถบันทึกข้อมูลได้ ข้อมูลไม่ถูกต้อง',
                    });
                })
        },
    });

    const onSuccessClick = () => {
        modal.confirm({
            title: 'ยืนยันการขายสินค้าเสร็จสิ้น ?',
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            onOk: () => mutate({
                values: {
                    "transaction_status": "COMPLETED",
                    "is_active": true
                }, id: order._id
            })
        });
    }
    const onCancelClick = () => {
        modal.confirm({
            title: 'ยกเลิกการขายสินค้า ?',
            okText: 'ตกลง',
            cancelText: 'ยกเลิก',
            onOk: () => mutate({
                values: {
                    "transaction_status": "CANCLED",
                    "is_active": true
                }, id: order._id
            })
        });
    }
    // console.log('order:', order);
    return (
        <Dropdown
            menu={{
                items: [
                    {
                        label: <Typography.Paragraph onClick={onSuccessClick} >เสร็จสิ้น</Typography.Paragraph>,
                        key: '1',
                    },
                    {
                        label: <Typography.Paragraph onClick={onCancelClick} style={{ color: '#ff4d4f' }}>ยกเลิก</Typography.Paragraph>,
                        key: '2',
                    },
                ],
            }}
        >
            <Button type='text' icon={<MoreOutlined />} />
        </Dropdown>
    )
}

function ChangeOrderStatus({ order }) {
    return (
        <App>
            <TransactionStatusModal order={order} />
        </App>
    )
}

export default ChangeOrderStatus;